import {sumBy} from 'lodash';

export const getInfoSalesData = (
  infoType,
  {salesByDealersList, salesByModelsList, salesByColorsList}
) => {
  if (infoType === 'dealers') {
    return salesByDealersList;
  }
  if (infoType === 'models') {
    return salesByModelsList;
  }
  return salesByColorsList;
};

export const getTotalQuantity = (infoType, props) => {
  const {salesByDealersList, salesByModelsList, salesByColorsList} = props;

  if (infoType === 'dealers') {
    return sumBy(salesByDealersList, 'quantity');
  }
  if (infoType === 'models') {
    return sumBy(salesByModelsList, 'quantity');
  }
  return sumBy(salesByColorsList, 'quantity');
};

export const getNextInfoType = (infoType, type) => {
  let newInfoType = '';
  if (infoType === 'dealers') {
    if (type === 'stock models') {
      newInfoType = 'reservations';
    } else {
      newInfoType = 'models';
    }
  }
  if (infoType === 'models') {
    if (type === 'sales') {
      newInfoType = 'colors';
    } else if (type === 'stock dealers') {
      newInfoType = 'reservations';
    } else {
      newInfoType = 'dealers';
    }
  }
  if (infoType === 'reservations') {
    newInfoType = 'colors';
  }
  return newInfoType;
};

export const getInfoStockData = (infoType, props) => {
  const {
    stockByDealersList,
    stockByModelsList,
    stockByReservationsList,
    stockByColorsList,
  } = props;
  if (infoType === 'dealers') {
    return stockByDealersList;
  }
  if (infoType === 'models') {
    return stockByModelsList;
  }
  if (infoType === 'reservations') {
    return stockByReservationsList;
  }
  return stockByColorsList;
};

export const getTotalStock = (infoType, props) => {
  const {
    stockByDealersList,
    stockByModelsList,
    stockByReservationsList,
    stockByColorsList,
  } = props;

  if (infoType === 'dealers') {
    return sumBy(stockByDealersList, 'stock');
  }
  if (infoType === 'models') {
    return sumBy(stockByModelsList, 'stock');
  }
  if (infoType === 'reservations') {
    return sumBy(stockByReservationsList, 'stock');
  }
  return sumBy(stockByColorsList, 'stock');
};

